import {SectionInterface} from "../types/store";

function getAvailableSectionWidths(sections: SectionInterface[], sectionIndex: number): number[] {
    const base = sections[sectionIndex].width

    if ((sectionIndex === sections.length - 1) ||
        (sections[sectionIndex + 1].isIndent && (sections[sectionIndex + 2] && sections[sectionIndex + 2].isIndent)) ||
        (sections[sectionIndex + 1].isIndent && !sections[sectionIndex + 2])
    )
        return [base]

    const sum = sections[sectionIndex].width + sections[sectionIndex + 1].width

    return [base, sum]
}

export default getAvailableSectionWidths
